<template>
  <v-card class="mx-auto" elevation="4" @click="navigate">
    <v-card-title><slot name="title"></slot></v-card-title>
    <v-card-subtitle v-if="userTest">Induction Complete</v-card-subtitle>
    <v-card-text>
      <v-img v-if="item.thumbnailId" :src="image" max-width="100%"></v-img>
    </v-card-text>
  </v-card>
</template>

<script>
import ApiService from "@/services/ApiService.js";
import UserTestService from "@/services/UserTestService.js";
export default {
  props: {
    item: Object
  },
  data() {
    return {
      userTest: {}
    };
  },
  created() {
    this.getUserTest();
  },
  computed: {
    image() {
      return `${ApiService.getBaseUrl()}test/thumbnail/${
        this.item.thumbnailId
      }`;
    }
  },
  methods: {
    navigate() {
      if (this.userTest) {
        this.$router.push({
          name: "Results",
          params: { userTestId: this.userTest.userTestId }
        });
      } else {
        this.$router.push({
          name: "Induction",
          params: { testId: this.item.testId }
        });
      }
    },
    getUserTest() {
      UserTestService.getPassedTest(this.item.testId).then(response => {
        this.userTest = response;
      });
    }
  }
};
</script>

<style scoped></style>
